export const GET_TAGS='GET_TAGS'
export const GET_SESSION_TAGS = 'GET_SESSION_TAGS'
export const GET_CATEGORIES='GET_CATEGORIES' 
export const DELETE_TAGS='DELETE_TAGS'
export const UPDATE_TAGS='UPDATE_TAGS'
export const CREATE_TAGS='CREATE_TAGS'
export const ADD_TAG_TO_SESSION = 'ADD_TAG_TO_SESSION'
export const REMOVE_TAG_FROM_SESSION = 'REMOVE_TAG_FROM_SESSION'
